import { computed } from 'vue';
import { useShared } from '@othercommerce/foundation';

export function useWishlistProducts() {
  const shared = useShared();

  return computed(() => shared.value.wishlistsVariants || []);
}
